// TODO: IMPORTANT
// TODO: re-valuate this solution I believe we can improve and avoid all of these repetitions by exposing just one function and the CONSTANTS lke
/*
// TODO: this can even be injected from BE instead of being hardcoded declared here!
export const PERMISSIONS = {
  CAN_ROSTER_MANAGE: 'Can_Roster_Manage'
  CAN_VIEW_EMPLOYEES: 'Can_View_Employees'
}

export default checkPermission(permission = '') {
}
*/

/*
 * Return an array containing the permissions of the current user.
 * @return boolean
 */
function permissions() {
  return window?.$dt?.objConfig?.Me?.Permissions || [];
}

/*
 * Return a function which returns true when the current user has the permission
 * corresponding to the id argument.
 * @returns () => boolean
 */
function permissionsGetter(id) {
  return () => permissions().includes(id);
}

/**
 * Return whether the login user has administrative privilege or not.
 * @return {boolean}
 */
export function canAdmin() {
  return window?.$dt?.objConfig?.CanAdmin || false;
}

/**
 * Return whether the login user has permission to manage rosters or not.
 * @return {boolean}
 */
export function canRosterManage() {
  return permissions().includes('Can_Roster_Manage');
}

/**
 * Return whether the login user has permission to manage payroll or not.
 * @return {boolean}
 */
export function canManagePayroll() {
  return permissions().includes('Can_Manage_Payroll');
}

/**
 * Return whether the login user has permission to view employees.
 * @return {boolean}
 */
export function canViewEmployees() {
  return permissions().includes('Can_View_Employees');
}

/**
 * Return whether the login user has permission to manage employees.
 * @return {boolean}
 */
export function canManageEmployees() {
  return permissions().includes('Can_Manage_Employees');
}

/**
 * Return whether the login user has permission to approve timesheets.
 * @return {boolean}
 */
export function canApproveTimesheetsHours() {
  return permissions().includes('Can_Approve_Timesheet_Hours');
}

/**
 * Return whether the login user has permission to manage departments.
 * @return {boolean}
 */
export function canManageDepartments() {
  return permissions().includes('Can_Manage_Departments');
}

/**
 * Return whether the login user has permission to edit business.
 * @return {boolean}
 */
export function canEditBusiness() {
  return permissions().includes('Can_Edit_Business');
}

/**
 * Return whether the login user have the access to edit DeputecCompany
 * @return {boolean}
 */
export function canEditWorkplace() {
  return window?.$dt?.objConfig?.CanEditWorkplace || false;
}

export const canRosterAllDepartments = permissionsGetter(
  'Can_Roster_All_Departments'
);

export const canApproveTSAllDepartments = permissionsGetter(
  'Can_ApproveTS_All_Departments'
);

/**
 * Return a function which returns whether the login user has permission to access timesheet staging.
 * @type {function(): *}
 */
export const canAccessTimesheetStaging = permissionsGetter(
  'Can_Access_TS_Staging'
);
